import { styled } from '@mui/system';
import { Button } from '@mui/material';

export const CountButton = styled(Button)(({ theme }) => ({
  color: theme.palette.secondary.main,
  minWidth: 10,
  marginLeft: -8
}));

export const ShowAllButton = styled(Button)(() => ({
  paddingRight: 0
}));
